/* global globalThis */
// GES-296 Q2: ONE idempotency key per user ACTION. A double click re-sends the same key (the API dedupes it);
// a changed payload or a finished/closed action gets a fresh one.
export function newKey() {
  const c = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  // fallback (non-secure context / old browser): RFC 4122 v4 shape, which the API accepts as a UUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, ch => {
    const r = Math.floor(Math.random() * 16);
    return (ch === 'x' ? r : (r & 3) | 8).toString(16);
  });
}

// `holder` is a ref-like { current }. Same signature -> same key; different -> new key.
export function keyFor(holder, signature) {
  if (!holder.current || holder.current.sig !== signature) holder.current = { sig: signature, key: newKey() };
  return holder.current.key;
}

export const clearKey = holder => { holder.current = null; };

// The API returns { error } (EN) and { error_fr }; show the one for the UI language.
export function serverMessage(data, lang) {
  if (!data) return null;
  return (String(lang || '').startsWith('fr') && data.error_fr) || data.error || null;
}
